import { useState } from 'react'
import { Link } from 'react-router-dom';
import './styles.css'
import whatsapp from './../images/whatsapp.svg'

/*---components---*/
import Navbar from './../components/Navbar'
import MainHeading from './../components/MainHeading'
import  Footer from '../components/Footer'
/* ---images--- */
import imgMain2 from './../images/main_service.svg'
import imgRecruit from './../images/service_recruit.png'

function Services(){
  const [vacanciesField, setVacanciesField] = useState(['nurses', 'it', 'Allied health', 'it'])

  return(
    <>
      <Navbar />
      <main className="services__page">
        <a className="whatsapp" href="//api.whatsapp.com/send?phone=+919871013411"><img src={whatsapp} alt="send a message" /></a>
        <MainHeading heading="services" />

        <section className="services__main">
          <div className="services__main__img">
            <img src={imgMain2} alt=""/>
          </div>
          <div className="services__main__content">
            <p>Recruitment of Nurses and healthcare assistants for the
            NHS and private healthcare institutions.</p>
            <p>Local and international recruitment of healthcare personnel.</p>
            <p>Provide support and advise for healthcare
            professionals looking for new opportunities.</p>
            <p>Educational support for international nurses and midwives
            looking to join the NHS and the private healthcare sector in the UK.</p>
            <p>Global healthcare recruitment</p>
          </div>
        </section>
        <section className="services__recruit">
          <h2>We recruit</h2>
          <div className="recruit__field--container">
            {vacanciesField.map((field, index)=>(
              <Link to="/Jobs"  className="recruit__field">
                <div key={index}>
                  <p>{field}</p>
                </div>
              </Link>
            ))}
          </div>
          <button className="services__recruit__btn"><Link to="/Jobs">Search vacancies</Link></button>

        </section>

      </main>
      <Footer />
    </>
  )
}

export default Services
